import {
  HttpBackend,
  HttpClient,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  finalize,
  map,
  Observable,
  of,
  shareReplay,
  tap,
} from 'rxjs';
import { environment } from 'src/environments/environment';

interface CsrfTokenResponse {
  readonly token: string;
}

@Injectable({ providedIn: 'root' })
export class CsrfTokenService {
  private readonly http = new HttpClient(inject(HttpBackend));
  private token: string | null = null;
  private tokenRequest: Observable<string> | null = null;

  getToken(): Observable<string> {
    if (this.token) {
      return of(this.token);
    }

    if (!this.tokenRequest) {
      this.tokenRequest = this.fetchToken();
    }

    return this.tokenRequest;
  }

  clearToken(): void {
    this.token = null;
    this.tokenRequest = null;
  }

  private fetchToken(): Observable<string> {
    return this.http
      .get<CsrfTokenResponse>(`${environment.baseURl}/Auth/csrf`, {
        withCredentials: true,
      })
      .pipe(
        map((response) => response.token),
        tap((token) => {
          this.token = token;
        }),
        finalize(() => {
          this.tokenRequest = null;
        }),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
  }
}
